import Index from "./views/Index.vue";

const menus = [
  {
    path: "/",
    name: "index",
    component: Index,
    meta: {
      title: `公司首页 | 北京海源恒智科技有限公司`,
      menu: "公司首页"
    }
  },
  {
    path: "/about",
    name: "about",
    meta: {
      title: `公司简介 | 北京海源恒智科技有限公司`,
      menu: `公司简介`
    },
    component: () => import("./views/About.vue")
  },
  {
    path: "/solution",
    name: "solution",
    meta: {
      title: `解决方案 | 北京海源恒智科技有限公司`,
      menu: `解决方案`
    },
    component: () => import("./views/Solution.vue")
  },  
  {
    path: "/contact",
    name: "contact",
    meta: {
      title: `联系我们 | 北京海源恒智科技有限公司`,
      menu: `联系我们`
    },
    component: () => import("./views/Contact.vue")
  },
];
export default menus;